export default __webpack_public_path__ + "static/media/more-options.85123905.svg";